<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title"></span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>


  <div class="ttmodal__body">
      <!-- <div class="center">
          <mat-spinner></mat-spinner>
      </div> -->
      <div>
          <div  class="photo-container"><img  class="photo-container__photo"  [src]="getImage(image)" /></div>
         
      </div>
  </div>
  <div class="ttmodal__footer" style="display: flex;">
    <a class="button" (click)="openEditImageComponent()"><span class="material-icons button__icon">edit</span><span class="button__text">Edit</span></a>
    <div (click)="fileInput.click()" title="{{'Add photo' | translate | async}}" style="margin-right: 8px;">
      <a class="button"><span class="material-icons button__icon">cloud_upload</span><span class="button__text">Replace Photo</span></a>
          <input style="display: none;" type="file"
                 #fileInput
                 (change)="onSelectPhoto($event)">
    </div>

    <a class="button" style="margin-right: 8px;" (click)="deletePhoto()"><span class="material-icons button__icon">delete</span><span class="button__text">Delete</span></a>
  </div>
</div>



